import { AnimatePresence, motion } from "motion/react";

import { useSearchParams } from "react-router-dom";

import Modal from "@/components/staff/modals/Modal.tsx";

import useModalRouter from "@/hooks/useModalRouter";
import { cn } from "@/utils/cn";

import modalRoutes from "./ModalRoutes";
import { matchModalRoutes, useModalPath } from "./utils";

export const ModalRouter = () => {
  const pathParts = useModalPath();
  const matchedRoutes = matchModalRoutes(modalRoutes, pathParts);
  const [params] = useSearchParams();
  const modal = params.get("modal");

  const { closeModal } = useModalRouter();

  const [currentSegment] = pathParts;
  const currentRoute = modalRoutes.find((r) => r.name === currentSegment);
  const Component = currentRoute?.component;
  const bgColor = currentRoute?.bgColor ?? "var(--surface)";

  return (
    <Modal
      isOpen={Boolean(matchedRoutes.length)}
      closeModal={closeModal}
      style={{ background: bgColor }}
      className={cn("max-w-max", {
        "overflow-x-auto": !modal?.match("success"),
      })}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={currentRoute?.name}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          {Component && <Component />}
        </motion.div>
      </AnimatePresence>
    </Modal>
  );
};

export default ModalRouter;
